export const museoSans100normal = {
  fontFamily: 'Museo Sans',
  src: `url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_100-webfont.eot'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_100-webfont.eot?#iefix') format('embedded-opentype'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_100-webfont.woff2') format('woff2'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_100-webfont.woff') format('woff'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_100-webfont.ttf') format('truetype'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_100-webfont.svg#museo_sans100') format('svg')
      `,
  fontWeight: '100',
  fontStyle: 'normal'
};

export const museoSans100italic = {
  fontFamily: 'Museo Sans',
  src: `url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_100_Italic-webfont.eot'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_100_Italic-webfont.eot?#iefix') format('embedded-opentype'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_100_Italic-webfont.woff2') format('woff2'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_100_Italic-webfont.woff') format('woff'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_100_Italic-webfont.ttf') format('truetype'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_100_Italic-webfont.svg#museo_sans100_italic') format('svg')
      `,
  fontWeight: '100',
  fontStyle: 'italic'
};

export const museoSans300normal = {
  fontFamily: 'Museo Sans',
  src: `url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_300-webfont.eot'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_300-webfont.eot?#iefix') format('embedded-opentype'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_300-webfont.woff2') format('woff2'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_300-webfont.woff') format('woff'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_300-webfont.ttf') format('truetype'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_300-webfont.svg#museo_sans300') format('svg')
      `,
  fontWeight: '300',
  fontStyle: 'normal'
};

export const museoSans300italic = {
  fontFamily: 'Museo Sans',
  src: `url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_300_Italic-webfont.eot'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_300_Italic-webfont.eot?#iefix') format('embedded-opentype'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_300_Italic-webfont.woff2') format('woff2'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_300_Italic-webfont.woff') format('woff'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_300_Italic-webfont.ttf') format('truetype'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_300_Italic-webfont.svg#museo_sans300_italic') format('svg')
      `,
  fontWeight: '300',
  fontStyle: 'italic'
};

export const museoSans500normal = {
  fontFamily: 'Museo Sans',
  src: `url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_500-webfont.eot'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_500-webfont.eot?#iefix') format('embedded-opentype'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_500-webfont.woff2') format('woff2'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_500-webfont.woff') format('woff'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_500-webfont.ttf') format('truetype'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_500-webfont.svg#museo_sans500') format('svg')
      `,
  fontWeight: '500',
  fontStyle: 'normal'
};

export const museoSans500italic = {
  fontFamily: 'Museo Sans',
  src: `url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_500_Italic-webfont.eot'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_500_Italic-webfont.eot?#iefix') format('embedded-opentype'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_500_Italic-webfont.woff2') format('woff2'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_500_Italic-webfont.woff') format('woff'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_500_Italic-webfont.ttf') format('truetype'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_500_Italic-webfont.svg#museo_sans500_italic') format('svg')
      `,
  fontWeight: '500',
  fontStyle: 'italic'
};

export const museoSans700normal = {
  fontFamily: 'Museo Sans',
  src: `url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_700-webfont.eot'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_700-webfont.eot?#iefix') format('embedded-opentype'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_700-webfont.woff2') format('woff2'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_700-webfont.woff') format('woff'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_700-webfont.ttf') format('truetype'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_700-webfont.svg#museo_sans700') format('svg')
      `,
  fontWeight: '700',
  fontStyle: 'normal'
};

export const museoSans700italic = {
  fontFamily: 'Museo Sans',
  src: `url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_700_Italic-webfont.eot'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_700_Italic-webfont.eot?#iefix') format('embedded-opentype'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_700_Italic-webfont.woff2') format('woff2'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_700_Italic-webfont.woff') format('woff'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_700_Italic-webfont.ttf') format('truetype'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_700_Italic-webfont.svg#museo_sans700_italic') format('svg')
      `,
  fontWeight: '700',
  fontStyle: 'italic'
};

export const museoSans900normal = {
  fontFamily: 'Museo Sans',
  src: `url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_900-webfont.eot'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_900-webfont.eot?#iefix') format('embedded-opentype'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_900-webfont.woff2') format('woff2'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_900-webfont.woff') format('woff'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_900-webfont.ttf') format('truetype'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_900-webfont.svg#museo_sans900') format('svg')
      `,
  fontWeight: '900',
  fontStyle: 'normal'
};

export const museoSans900italic = {
  fontFamily: 'Museo Sans',
  src: `url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_900_Italic-webfont.eot'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_900_Italic-webfont.eot?#iefix') format('embedded-opentype'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_900_Italic-webfont.woff2') format('woff2'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_900_Italic-webfont.woff') format('woff'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_900_Italic-webfont.ttf') format('truetype'),
      url('https://cdn.appsflyer.com/fonts/museo_sans/MuseoSans_900_Italic-webfont.svg#museo_sans900_italic') format('svg')
      `,
  fontWeight: '900',
  fontStyle: 'italic'
};
